import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function quizListModel() {
  const fetchQuizListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/List_Quiz_Group",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "status", Value: 0 }],
      Ordering: [],
    },
  });

  const fetchQuizDetailModel = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/Detail_Quiz_Group",
    method: "POST",
    payload: {
      GroupId: null,
    },
  });

  const createQuizInformation = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/Create_Quiz_Group",
    method: "POST",
    payload: {
      Title_Name: "",
      Quiz_Name: "",
      Desc: "",
      Function_Type: 1,
      Cover_ImageURL: "",
      Display_ImageURL: "",
      IsLimit: "",
      Limit: "",
      Status: "",
      Valid_From: "",
      Valid_Through: "",
    },
  });

  const updateQuestionModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Quiz/Create_Update_Quiz",
    method: "POST",
    payload: {
      GroupId: "",
      Quiz_List: [
        {
          QuizId: 1,
          Seq_Quiz: 1,
          Qiuz_Name_HTML_Editor: "",
          Quiz_Desc_HTML_Editor: "",
          Input_Type: 1,
          Choice_Mode: 1,
          Permission_Type: 1,
          Quiz_Image_URL: "",
          Duplicate_Quiz_Image_URL: "",
          Option_List: [
            {
              OptionId: 1,
              Name: "",
              Seq_Option: "",
              Iscorrect: "",
              Remark: "",
              Image: "",
              Duplicate_Option_Image_URL: "",
            },
          ],
        },
      ],
    },
  });

  const editQuizInformation = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/Update_Quiz_Group",
    method: "POST",
    payload: {
      GroupId: null,
      Title_Name: "",
      Quiz_Name: "",
      Desc: "",
      Function_Type: 1,
      Cover_ImageURL: "",
      Display_ImageURL: "",
      IsLimit: "",
      Limit: "",
      Status: "",
      Reply_Type: 1,
      Valid_From: "",
      Valid_Through: "",
    },
  });

  const deleteQuiz = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/Delete_Quiz_Group",
    method: "POST",
    payload: {
      GroupId: null,
    },
  });

  const toggleStatus = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/Change_Status",
    method: "POST",
    payload: {
      GroupId: null,
      Status_Group: null,
    },
  });

  const updatePermission = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/Create_Update_Permission",
    method: "POST",
    payload: {
      GroupId: 4,
      Permission_Type: 1,
      IsLimit: 1,
      Limit: null,
      Tag_Quizzer: [{ Tag_Name: "tier-choco678" }],
      Tag_Visibility: [{ Tag_Name: "tier-choco678" }],
    },
  });

  const fetchQuizListPermissionModel = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizGroup/List_Permission",
    method: "POST",
    payload: {
      GroupId: null,
    },
  });

  const CreateUpdateReward = reactive({
    api: apiEndpoint.bcrm_platform + "/Quiz/Update_Reward",
    method: "POST",
    payload: {
      GroupId: 4,
      Info_Reward:
      {
        Quiz_Reward_Type: 2,
        IsEqual: 1,
        Criteria_Type: 4,
        Minimun_Correct: null
      },
      Criteria_Reward: [
        {
          TagId: 64,
          PrivilegeId: null,
          InventoryId: null,
          Point: 5
        }]

    },
  });

  const fetchInventoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/List",
    method: "POST",
    payload: {},
  });

  const fetchEntryInventoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Entry_List",
    method: "POST",
    payload: {
      Inventory_Id: 0,
    },
  });

  const fetchQueryDisplayDashboard = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizDashboard/Display",
    method: "POST",
    payload: {
      Quiz_GroupId: 0,
    },
  });

  const fetchQueryDataDashboard = reactive({
    api: apiEndpoint.bcrm_platform + "/QuizDashboard/Query",
    method: "POST",
    payload: {
      CardId: "",
      Quiz_GroupId: null,
      QuestionId: null,
      Key: "",
    },
  });

  return {
    fetchQuizListModel,
    createQuizInformation,
    updateQuestionModel,
    editQuizInformation,
    fetchQuizDetailModel,
    deleteQuiz,
    toggleStatus,
    updatePermission,
    fetchQuizListPermissionModel,
    CreateUpdateReward,
    fetchInventoryList,
    fetchEntryInventoryList,
    fetchQueryDisplayDashboard,
    fetchQueryDataDashboard,
  };
}
